export default __webpack_public_path__ + "static/shopify-plus-partner-logo-0b5e85f4172c956a151b3fe52aa47f16.png";